import { render, staticRenderFns } from "./ProductForm.vue?vue&type=template&id=003f9a9f&scoped=true&"
import script from "./ProductForm.vue?vue&type=script&lang=ts&"
export * from "./ProductForm.vue?vue&type=script&lang=ts&"
import style0 from "./ProductForm.vue?vue&type=style&index=0&id=003f9a9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003f9a9f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('003f9a9f')) {
      api.createRecord('003f9a9f', component.options)
    } else {
      api.reload('003f9a9f', component.options)
    }
    module.hot.accept("./ProductForm.vue?vue&type=template&id=003f9a9f&scoped=true&", function () {
      api.rerender('003f9a9f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/ProductForm.vue"
export default component.exports